const Form089EN = {
    stepName: {
        importantNotes: "Important Notes",
        basicInfo: "Grant Application",
        useOfTheGrant:
            "Overview on the Use of Grant in the Previous School Year",
        schoolInfo: "School information",
        confirmation: "Confirmation",
    },

    label: {
        statementHeader: "Note",
        statement:
            "I have read, understand and agree to the above terms and conditions.",
        applicationForTheGrantOption: {
            applicationForTheGrant1:
                "Our school would like to apply for the Student Activities Support Grant. We will comply with the guidelines and will fully utilise the Grant to support students with financial needs in our school to participate in life-wide learning activities organised or recognised by our school.",
            applicationForTheGrant2:
                "Our school does not intend to apply for the Student Activities Support Grant.",
        },

        noOption: {
            supportStudents:
                "Our school will deploy other resources to support students with financial needs to participate in life-wide learning activities.",
            others: "Other reason:",
        },
        reason: "reason",
        schoolTypeOption: {
            primary: "Primary",
            secondary: "Secondary",
            PrimaryCumSecondary: "Primary-cum-Secondary",
            special: "Special ",
        },
        basicInfo: "Grant Application",
        header: "Student Activities Support Grant ({{schoolyear}} School Year) Application Form  ",
        header1:
            " (Please return the completed form by fax or by post to the Education Bureauon or before {{deadline}})",
        applicationForTheGrant: "I) Application for the Grant ",
        toolTip: "(please “√” as appropriate)",
        useOfTheGrant:
            "Overview on the Use of Grant in the Previous School Year",
        title: "II) Overview on the Use of the Grant in {{previousSchoolYear}}s.y. ",
        toolTip1:
            "Please provide the estimated total expenditure in {{previousSchoolYear}} s.y..",
        startDate: "The academic year from",
        endDate: "The academic year to",
        estimated: "Estimated Expenditure in 2020/21s.y.",
        table: {
            category: "Category",
            expectedNumberOfStudentBeneficiaries:
                "Expected Number of Student Beneficiaries",
            expectedSubsidisedAmount: "Expected Subsidised Amount",
        },

        expenditure: "Estimated Expenditure in {{previousSchoolYear}}s.y.",

        specify1:
            "(capped at 25% of the total allocation for {{previousSchoolYear}}s.y.)",
        // total: "TOTAL",
        schoolInfo: "School information",
        comfirmation: "Confirmation",

        schoolName: "Name of School",
        schoolType: "School Type",
        schoolCode: "School Code(6 digits)",
        nameOfTeacherInCharge: "Name of Teacher-in-charge",
        post: "Post of Teacher-in-charge",
        emailAddressOfTeacherInCharge: "Email Address of Teacher-in-charge",
        ContactPhone: "Contact Phone No.",
        nameOfSupervisor: "Name of Supervisor",
        annotation: "Please indicate the",
        specify: "(6-digit code)",
        specify2: "Please specify:",
        applyGrant: "Did your school apply for the grant",
        applyGrantOption: {
            yes: "Yes",
            no: "No",
        },
    },
    importantNotes: {
        p1_1: "Personal Information Collection Statement",
        p1_2: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",

        p1_a: "processing employment-related matters;",
        p1_b: "processing Salaries Grant payment and calculation of provident fund contribution and donation;",
        p1_c: "auditing;",
        p1_d: "conducting research and compiling statistics to facilitate planning of education services;",
        p1_e: "processing matters relating to the development of the education profession;",
        p1_f: "administering and enforcing the Education Ordinance and Regulations and the Grant/Subsidized Schools Provident Fund Rules (Cap. 279).",

        p2: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        p3: "The personal data collected in this form may be disclosed to other government bureau/departments/agencies authorized to process such information for the purposes mentioned above.",
        p4: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        p5: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to Education Bureau.",
    },
    category: {
        category1: "Comprehensive Social Security Assistance",
        category2: "Full-grant under the School Textbook Assistance Scheme",
        category3: "Meeting the school-based financially needy criteria",
        total: "TOTAL",
    },
    errorMsg: {
        schoolName: "Please input a valid name of school.",
        schoolCode: "Please input a valid school code.",
        teacherName: "Please input a valid Name of Teacher.",
        post: "Please input a valid post.",
        email: "Please input a valid email address.",
        phoneNo: "Please input a valid Contact Phone number.",
        otherInput: "Please input a valid reason.",
        E0001: "Please input a 6-digit code.",
        // E0002: "Please input a valid phone number  (cannot be an English character)",
        // E0003: "Please input a valid email address of Teacher-in-charge",
        E0002: "(1) and (2) cannot be chosen at the same time.",
        E0003: "(2a) and (2b) cannot be chosen at the same time.",
        E0004: "If you chose Others. Please input a valid reason.",
        E0005: "Please input a valid number.",

        // E0007: "Please input a valid name ",
        // E0008: "Please input a valid position ",
        // E0001: "A number which is not a fraction; a whole number",
        // E0002: "Please input a valid telephone number",
        // E0003: "Please input a valid email address of Teacher-in-charge",
        // E0004: "(i) and (ii) cannot be chosen at the same time.",
        // E0005: "(iii) and (iv) cannot be chosen at the same time.",
        // E0006: "If you chose Others. Please write down specification",
        // E0007: "Please enter the correct name ",
        // E0008: "Please enter the correct position ",
        // E0009: "The minimum value of this field is 1",
        E0010: "School code must be at least 6 digits.",
        E0011: "School code must be at most 6 digits.",
        E0012: "Contact Phone number must be 8 digits.",
        E0013: 'The "Estimated Expenditure" should be equal to the "Total Estimated Subsidised Amount"',
    },
};
export default Form089EN;
